import teamPhoto from '../images/home/teamPhoto.png';

// This is hard coded until we can actually connect with the database. It's not ideal.

const teamData = [
  {
    firstName: 'Kevin',
    lastName: 'Key',
    title: 'CEO',
    picture: { teamPhoto },
  },
  {
    firstName: 'Sara',
    lastName: 'Waters',
    title: 'COO',
    picture: { teamPhoto },
  },
  {
    firstName: 'Andrew',
    lastName: 'Allen',
    title: 'OperationsManager',
    picture: { teamPhoto },
  },

];
export default teamData;
